import React, {useContext, useState} from 'react';
import {Button, Scrollable, Icons, Popup} from 'components';
import {partialRight, over, openPopup, useToggle, stopPropagation} from 'helpers';
import css from './menu.module.scss';

export function Menu({ Menu = RenderChildren, onClick, className, ...props }) {
  const popup = useContext(Popup.Context);
  popup?.setClassName('compact');
  return (
    <Scrollable {...props} className={css('menu', className)} onClick={onClick || popup.close}>
      <Menu {...props} />
    </Scrollable>
  );
}

Menu.Handle = function Handle({ className, disabled, editable, ...props }) {
  return !disabled && editable && (
    <Icons.Ellipsis className={css('handle', className)} onClick={openPopup(Menu, props)} />
  );
}

Menu.Item = function Item({ className, enabled = true, ...props }) {
  return enabled && (
    <Button {...props} className={css('button', className)} tagName="span" />
  );
}

Menu.AdvanceItem = function AdvanceItem({ Component, ...props }) {
  const [ advanced, toggle ] = useToggle(false);
  const popup = useContext(Popup.Context);
  if (advanced) {
    return (
      <Component {...props} popup={popup} toggle={toggle} />
    );
  }
  return (
    <Menu.Item {...props} onClick={over(toggle, popup?.bounce)} />
  );
}

Menu.Radio = ({ checked, onClick, ...props }) => (
  <Menu.Item
    {...props}
    icon="check"
    aria-checked={checked}
    className="radio"
    onClick={over(stopPropagation, onClick)}
  />
);

Menu.Checkbox = ({ checked, pending, onClick, ...props }) => (
  <Menu.Item
    {...props}
    icon={pending ? 'spinner' : 'check'}
    aria-checked={checked}
    className="checkbox"
    onClick={over(stopPropagation, partialRight(onClick, { checked }))}
  />
);

Menu.DeleteItem = function DeleteItem({ onConfirm }) {
  const [ clicked, setClicked ] = useState();
  const popup = useContext(Popup.Context);
  const prompt = event => {
    event.stopPropagation();
    setClicked(true);
    popup.bounce();
  }
  const confirm = () => {
    popup.close();
    setTimeout(onConfirm, 150);
  }
  if (clicked) {
    return (
      <Popup.Menu.Item icon="check" className={css.deleteConfirm} onClick={confirm}>Confirm</Popup.Menu.Item>
    );
  }
  return (
    <Popup.Menu.Item icon="trash" className={css.delete} onClick={prompt}>Delete</Popup.Menu.Item>
  );
}

Menu.SubHeading = function SubHeading(props) {
  return (
    <Menu.Item {...props} className={css.subheading} />
  );
}

Menu.Tooltip = function Tooltip(props) {
  return (
    <Menu.Item {...props} className={css.tooltip} />
  );
}

Menu.Separator = function Separator() {
  return (
    <div className={css.separator} />
  );
}

function RenderChildren(props) {
  return props.children;
}
